import { sanitize } from "dompurify";
import { getMissingDataMessages } from "entities/Request/utils/getMissingDataMessages";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { userStore } from "entities/User/store/userStore";
import { Button } from "ui";
import "./MissingUserSapDataMessage.styles.css";

function MissingUserSapDataMessage() {
  const { t } = useTranslation(["Request", "Shared"]);
  const user = userStore((state) => state.user);
  const [messages, setMessages] = useState(null);

  useEffect(() => {
    getMissingDataMessages(setMessages);
  }, []);

  if (messages)
    return (
      <Card className="message-card">
        <Card.Header>
          <Card.Title>{t("missing_profile_data_title")}</Card.Title>
        </Card.Header>
        <Card.Body
          dangerouslySetInnerHTML={{
            __html: sanitize(messages[user.country_code] ?? messages.DEFAULT, {
              ADD_ATTR: ["target"],
            }),
          }}
        />
        <Card.Footer className="text-center">
          <Button as={Link} to="/" variant="primary">
            {t("buttons.confirm", { ns: "Shared" })}
          </Button>
        </Card.Footer>
      </Card>
    );
}

export default MissingUserSapDataMessage;
